import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
  selector: 'rd-container',
  template: ` <ng-content></ng-content> `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContainerComponent {
  @Input() additionalClasses = '';
  @HostBinding('class') get classes(): string {
    return ['max-w-[1024px] mx-auto px-4', this.additionalClasses]
      .filter(Boolean)
      .join(' ');
  }
}
